export default { options: { label: 'Brand Groups' } }
